export default __webpack_public_path__ + "fonts/fontello.aac7b9651b0a7aa8a239303d4d708222.woff2";